import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Decides whether geofence surfaces show happy-path (AI produced a suggested
 * boundary) or exception-path (AI found nothing) copy.
 *
 * Default: happy path (optimistic). The caller pushes exactly one authoritative
 * signal via `signalAiBoundary(hasBoundary)` — typically wired to
 * GeofenceEditor's onOsmResult. Once resolved either way, subsequent signals
 * are ignored, so deleting all polygons after a boundary was found doesn't
 * flip the copy under the host's feet. Bump `resetKey` to force a fresh
 * decision (e.g., a modal reopening against a new listing).
 */
export function useAiBoundaryDecision({ resetKey } = {}) {
    const [hasAiBoundary, setHasAiBoundary] = useState(true);
    const decidedRef = useRef(false);

    useEffect(() => {
        decidedRef.current = false;
        setHasAiBoundary(true);
    }, [resetKey]);

    const signalAiBoundary = useCallback((hasBoundary) => {
        if (decidedRef.current) return;
        decidedRef.current = true;
        setHasAiBoundary(Boolean(hasBoundary));
    }, []);

    return { hasAiBoundary, signalAiBoundary };
}
